import { createFileRoute, Link } from '@tanstack/react-router'
import { requireAnyPermission } from '@/lib/permissions/permissions'
import VaultPage from '@/components/vault/VaultPage'
import { useOrg } from '@/lib/states/session/hooks'
import { useOrgEntitlements } from '@/lib/hooks/useOrgEntitlements'
import { canUseVault } from '@/lib/billing/plans'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { ClientVaultLoadingState } from '@/components/client/ClientTabLoadingStates'

export const Route = createFileRoute(
  '/_auth/_dashboard/clients/$clientId/_layout/vault',
)({
  beforeLoad: () => {
    requireAnyPermission(['vault.client.read', 'vault.client.edit'])
  },
  component: ClientVaultPage,
  pendingComponent: ClientVaultLoadingState,
})

function ClientVaultPage() {
  const org = useOrg()
  const { data: entitlements } = useOrgEntitlements()
  const allowVault = canUseVault(entitlements)
  const { clientId } = Route.useParams()

  if (!org) {
    return null
  }

  if (!allowVault) {
    return (
      <div className="h-full min-h-0 w-full px-4 py-4 md:mx-auto md:w-[90%] md:px-0 md:py-8">
        <Card className="max-w-2xl">
          <CardHeader>
            <CardTitle>Vault requires Growth</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3 text-sm text-muted-foreground">
            <p>
              Upgrade to Growth or above to use client vaults and shared
              resources.
            </p>
            <Button asChild size="sm">
              <Link to="/upgrade" search={{ plan: 'growth_monthly' }}>
                View upgrade options
              </Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    )
  }

  return (
    <div className="h-full min-h-0 w-full md:mx-auto md:w-[90%] px-4 lg:px-0">
      <VaultPage
        orgId={org.id}
        scope="client"
        clientId={clientId}
        title="Client Vault"
      />
    </div>
  )
}
